import React, { Component } from 'react';
// eslint-disable-next-line
import DeviceData from 'drivers/deviceData';
import ReactDOM from 'react-dom';
import Route from 'enum/route.enum';
import { Navigate } from 'react-router-dom';

import EventBus from 'utils/eventBus';
import BackCursor from 'components/common/nav/backCursor';
import LanguagePopUp from 'components/settings/languageModal/languageModal ';
import { loadLanguagesFromStorage, persistLocale } from 'utils/settings/languageUtils';
import { loadHdmiPortsForSettings, mapSourcesToSettingsItems, buildSourceRoutePath } from 'utils/hdmi/hdmiSettingsData';

import {
  GlassContainer,
  GlassCard,
  Header,
  Grid,
  InteractiveItem,
  ItemContent,
} from 'components/styles/Common.styled';
import getIsRTLLanguage from 'utils/common/isRTL';
import { translate as t } from 'utils/i18n';

class Setting extends Component {
  constructor(props) {
    super(props);
    this.subscriptions = {};
    this.state = {
      isModal: true,
      language_id: 0,
      redirectBack: false,
      focusIndex: 0,
      language_code: '',
      language: [],
      items: [],
      hideFooter: false,
      modalLanguageShow: false,
      isLanguageModal: true,
      hdmiRedirectPort: null,
      sourceRedirect: null,
    };
    this.onKeyPress = this.onKeyPress.bind(this);
    this.getData = this.getData.bind(this);
  }
  async componentDidMount() {
    this.subscriptions = EventBus.subscribe('refresh', this.getData);
    window.addEventListener('keydown', this.onKeyPress);
    this.getData();
    DeviceData.addHdmiSourceChangeListener(this.applyHdmiItems.bind(this));
  }
  async getData() {
    const { languages, selectedLanguageId } = loadLanguagesFromStorage();

    const buttons = [
      {
        id: 'language',
        title: t('buttons.languageTittle'),
        icon: 'fa fa-language',
        isLanguage: true,
      },
    ];

    const hdmiPorts = await loadHdmiPortsForSettings();
    hdmiPorts.forEach(function (port) {
      buttons.push({
        id: port.id,
        title: port.label,
        icon: 'fa fa-tv',
        sourceType: port.sourceType,
        sourceNumber: port.number,
      });
    });

    const focusIndex = Math.min(this.state.focusIndex, Math.max(0, buttons.length - 1));
    const activeButtons = buttons.map((button, index) => {
      return Object.assign({}, button, { active: index === focusIndex });
    });

    this.setState({
      language_id: selectedLanguageId,
      items: activeButtons,
      language: languages,
      focusIndex: focusIndex,
    });
  }

  applyHdmiItems(inputs) {
    var self = this;
    var sourceItems = mapSourcesToSettingsItems(inputs || []);

    self.setState(function (prev) {
      var buttons = [
        {
          id: 'language',
          title: t('buttons.languageTittle'),
          icon: 'fa fa-language',
          isLanguage: true,
        },
      ];
      sourceItems.forEach(function (port) {
        buttons.push({
          id: port.id,
          title: port.label,
          icon: 'fa fa-tv',
          sourceType: port.sourceType,
          sourceNumber: port.number,
        });
      });
      var focusIndex = Math.min(prev.focusIndex, Math.max(0, buttons.length - 1));
      return {
        items: buttons.map(function (button, index) {
          return Object.assign({}, button, { active: index === focusIndex });
        }),
        focusIndex: focusIndex,
      };
    });
  }
  componentWillUnmount() {
    this.subscriptions.unsubscribe();
    window.removeEventListener('keydown', this.onKeyPress);
    DeviceData.removeHdmiSourceChangeListener();
    clearInterval(this.interval);
  }

  handleSelectChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,
    });
  };

  setLocale = (languageId) => {
    if (languageId !== null) {
      this.setState({ language_id: languageId });
    }

    const languageCode = persistLocale(languageId, this.state.language);
    if (languageCode) {
      this.setState({ language_code: languageCode });
    }
  };

  markApiCallInProgress(inProgress) {
    this.setState({ apiCallInProgress: inProgress });
  }
  toogleCancel = (e) => {
    this.setState(
      {
        modalLanguageShow: false,
        focusIndex: 0,
      },
      function () {
        console.log(this.state.focusIndex);
        this.toggleItem(this.state.items[this.state.focusIndex]);
      }
    );
  };
  centerActiveItem() {
    const scrollContainer = ReactDOM.findDOMNode(this.scrollRef);
    const activeItem = ReactDOM.findDOMNode(this.activeRef);

    if (!activeItem || !scrollContainer) {
      return;
    }

    const scrollRect = scrollContainer.getBoundingClientRect();
    const activeRect = activeItem.getBoundingClientRect();

    this.setState((state) => {
      return {
        scrollPosition:
          activeRect.left - scrollRect.left - (scrollRect.width / 2 + activeRect.width / 2),
      };
    });
  }

  handleSelectedLanguage = (languageId) => {
    if (languageId !== null) {
      this.setLocale(languageId.id);
    }
  };

  toggleItem(currentItem) {
    this.setState(
      (state) => {
        return {
          items: state.items.map((item) => {
            item.active = currentItem.id === item.id;
            return item;
          }),
        };
      },
      () => {
        this.centerActiveItem();
      }
    );
  }
  clickHandler(event, index, currentItem) {
    if (currentItem.isLanguage) {
      this.setState({ hideFooter: true, modalLanguageShow: true });
    } else if (currentItem.sourceType && currentItem.sourceNumber != null) {
      this.setState({
        sourceRedirect: { type: currentItem.sourceType, number: currentItem.sourceNumber },
      });
    }
    this.toggleItem(currentItem);

    this.setState({
      focusIndex: index,
    });
  }

  async onKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();

    let newIndex;
    let enter = false;
    const isRTL = getIsRTLLanguage();

    const keyMapping = {
      [tvKeyControls.KEY_UP]: isRTL ? tvKeyControls.KEY_DOWN : tvKeyControls.KEY_UP,
      [tvKeyControls.KEY_DOWN]: isRTL ? tvKeyControls.KEY_UP : tvKeyControls.KEY_DOWN,
      [tvKeyControls.KEY_LEFT]: isRTL ? tvKeyControls.KEY_RIGHT : tvKeyControls.KEY_LEFT,
      [tvKeyControls.KEY_RIGHT]: isRTL ? tvKeyControls.KEY_LEFT : tvKeyControls.KEY_RIGHT,
    };
    if (!this.state.modalLanguageShow) {
      switch (event.keyCode) {
        case keyMapping[tvKeyControls.KEY_DOWN]:
        case keyMapping[tvKeyControls.KEY_RIGHT]:
          newIndex = this.state.focusIndex + 1;
          break;
        case keyMapping[tvKeyControls.KEY_UP]:
        case keyMapping[tvKeyControls.KEY_LEFT]:
          newIndex = this.state.focusIndex - 1;
          break;
        case tvKeyControls.KEY_ENTER:
          newIndex = this.state.focusIndex;
          enter = true;
          break;
        case tvKeyControls.KEY_BACK:
          if (this.state.modalLanguageShow !== true)
            this.setState({
              redirectBack: true,
            });
          event.preventDefault();
          break;
        default:
          break;
      }
    }
    if (this.state.items.length === newIndex) newIndex = 0;

    if (newIndex < 0) newIndex = this.state.items.length - 1;

    if (enter) {
      const item = this.state.items[newIndex];
      if (item && item.isLanguage) {
        this.setState({
          modalLanguageShow: true,
          hideFooter: true,
        });
      } else if (item && item.sourceType && item.sourceNumber != null) {
        this.setState({
          sourceRedirect: { type: item.sourceType, number: item.sourceNumber },
        });
      }
    }

    if (newIndex >= 0 && newIndex < this.state.items.length) {
      this.setState(
        {
          focusIndex: newIndex,
        },
        function () {
          this.toggleItem(this.state.items[this.state.focusIndex]);
        }
      );
    }
  }

  render() {
    const { items, modalLanguageShow } = this.state;
    const active = this.state.isModal ? 'is-active' : '';

    if (this.state.redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }

    if (this.state.sourceRedirect != null) {
      var redirect = this.state.sourceRedirect;
      return (
        <Navigate
          to={buildSourceRoutePath(redirect.type, redirect.number)}
          state={{ returnTo: Route.route.SETTINGS }}
        />
      );
    }

    if (this.state.hdmiRedirectPort != null) {
      return (
        <Navigate
          to={Route.route.HDMI + '/' + this.state.hdmiRedirectPort}
          state={{ returnTo: Route.route.SETTINGS }}
        />
      );
    }

    return (
      <div className='App'>
        <Header>
          <BackCursor />
          <h1>{t('Settings.settings')}</h1>
        </Header>
        <GlassContainer>
          {!modalLanguageShow && (
            <GlassCard>
              <Grid>
                {items !== null &&
                  items.length > 0 &&
                  items.map((item, i) => (
                    <InteractiveItem
                      key={i}
                      active={item.active}
                      ref={(ref) => {
                        if (item.active) {
                          this.activeRef = ref;
                        }
                      }}
                      onClick={(e) => this.clickHandler(e, i, item)}
                    >
                      <ItemContent>
                        <i className={item.icon}></i>
                        <h3>{item.title}</h3>
                        <p>
                          {item.isLanguage
                            ? t('Settings.languageDescription')
                            : item.sourceType
                              ? t('Hdmi.input_description')
                              : t('Settings.deviceLocationDescription')}
                        </p>
                      </ItemContent>
                    </InteractiveItem>
                  ))}
              </Grid>
            </GlassCard>
          )}

          {modalLanguageShow && (
            <LanguagePopUp
              show={modalLanguageShow}
              getItem={this.handleSelectedLanguage}
              value={this.state.language}
              cancel={this.toogleCancel}
            />
          )}
        </GlassContainer>
      </div>
    );
  }
}

export default Setting;
